import { OddsButton } from "@/components/OddsButton";
import { kickoff } from "@/lib/api";

const Team = ({ name, logo, score, showScore, win }) => (
  <div className="flex items-center gap-2 min-w-0">
    {logo ? (
      <img src={logo} alt="" className="h-5 w-5 shrink-0 object-contain" loading="lazy" />
    ) : (
      <span className="h-5 w-5 shrink-0 rounded-full bg-[#1E293B]" />
    )}
    <span className={`truncate text-sm ${win ? "font-bold text-[#10B981]" : "text-slate-100"}`}>{name}</span>
    {showScore && <span className="ml-auto pl-2 font-odds text-sm font-bold text-white">{score ?? 0}</span>}
  </div>
);

export const StatusTag = ({ ev }) => {
  if (ev.state === "in")
    return (
      <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-[#EF4444]">
        <span className="live-dot h-1.5 w-1.5 rounded-full bg-[#EF4444]" /> Live · {ev.status_detail}
      </span>
    );
  if (ev.state === "post") return <span className="text-[11px] uppercase tracking-wider text-slate-400">{ev.status_detail}</span>;
  return <span className="text-[11px] uppercase tracking-wider text-slate-400">{kickoff(ev.start)}</span>;
};

export const EventRow = ({ ev, showOdds = true }) => {
  const showScore = ev.state !== "pre";
  return (
    <div
      data-testid={`event-row-${ev.id}`}
      className="grid grid-cols-1 gap-3 border-b border-[#1E293B] px-3 py-3 transition-colors hover:bg-[#151c2b] sm:grid-cols-[1fr_auto] sm:items-center sm:px-4"
    >
      <div className="min-w-0 space-y-1.5">
        <div className="flex items-center gap-2">
          <StatusTag ev={ev} />
          {ev.tournament && <span className="truncate text-[11px] text-slate-500">· {ev.tournament}</span>}
          {ev.boosted && <span className="rounded bg-[#F59E0B]/15 px-1.5 py-0.5 text-[9px] font-black uppercase text-[#F59E0B]">Odds boost</span>}
        </div>
        <Team name={ev.home} logo={ev.home_logo} score={ev.home_score} showScore={showScore} win={ev.winner === "home"} />
        <Team name={ev.away} logo={ev.away_logo} score={ev.away_score} showScore={showScore} win={ev.winner === "away"} />
      </div>
      {showOdds && (
        <div className="flex gap-1.5 sm:w-[260px]">
          <OddsButton ev={ev} pick="home" label="1" />
          {ev.three_way && <OddsButton ev={ev} pick="draw" label="X" />}
          <OddsButton ev={ev} pick="away" label="2" />
        </div>
      )}
      {!showOdds && ev.winner && (
        <span data-testid={`result-${ev.id}`} className="rounded bg-[#10B981]/15 px-2 py-1 text-xs font-semibold text-[#10B981]">
          {ev.winner === "draw" ? "Draw" : `${ev.winner === "home" ? ev.home : ev.away} won`}
        </span>
      )}
    </div>
  );
};
